import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useCallback, useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useEmrContext } from "@/hooks/emr-context";
import { useComposerStore } from "@/stores/composers";
import { usePatientTagsStore, ChangeMode } from "@/stores/patient-tags";
import { getInitialState } from "@/components/patient-tags/get-initial-state";
import { isTagEmpty } from "@/components/patient-tags/is-tag-empty";
import { bulkUpdateTags } from "@/services/patient-tags";
import { patchServerTags } from "@/utils/tags";
import { usePatientTagsQuery, useCustomFieldsQuery } from "./use-patient-tags-data";

/** Main controller for the patient tags panel. */
export function usePatientTags() {
  var _fieldsQuery$data2;
  var _useEmrContext = useEmrContext(),
    workspaceId = _useEmrContext.workspaceId,
    patientUid = _useEmrContext.patientUid;
  var tagsQuery = usePatientTagsQuery(patientUid);
  var fieldsQuery = useCustomFieldsQuery(workspaceId);
  var setTagsEditMode = useComposerStore(function (s) {
    return s.setTagsEditMode;
  });
  var serverTags = usePatientTagsStore(function (s) {
    return s.serverTags;
  });
  var setServerTags = usePatientTagsStore(function (s) {
    return s.setServerTags;
  });
  var _usePatientTagsStore = usePatientTagsStore(),
    patientTags = _usePatientTagsStore.patientTags,
    order = _usePatientTagsStore.order,
    isEditingMode = _usePatientTagsStore.isEditingMode,
    addTag = _usePatientTagsStore.addTag,
    editTag = _usePatientTagsStore.editTag,
    deleteTag = _usePatientTagsStore.deleteTag,
    revertTag = _usePatientTagsStore.revertTag,
    resetTags = _usePatientTagsStore.resetTags;
  var _useState = useState(false),
    isSaving = _useState[0],
    setIsSaving = _useState[1];
  var _useState2 = useState(new Set()),
    shakingTagIds = _useState2[0],
    setShakingTagIds = _useState2[1];
  useEffect(function () {
    var _tagsQuery$data$map, _tagsQuery$data;
    setServerTags((_tagsQuery$data$map = (_tagsQuery$data = tagsQuery.data) === null || _tagsQuery$data === void 0 ? void 0 : _tagsQuery$data.map(function (t) {
      return {
        tag_id: t.tag_id,
        response: t.response
      };
    })) !== null && _tagsQuery$data$map !== void 0 ? _tagsQuery$data$map : []);
  }, [patientUid, tagsQuery.data]);
  useEffect(function () {
    var _getInitialState = getInitialState(serverTags),
      pt = _getInitialState.patientTags,
      o = _getInitialState.order;
    resetTags(pt, o);
  }, [patientUid, serverTags]);
  useEffect(function () {
    setTagsEditMode(isEditingMode);
    return function () {
      return setTagsEditMode(false);
    };
  }, [isEditingMode]);
  var mutation = useMutation(function (body) {
    return bulkUpdateTags(patientUid, body);
  });
  var handleSave = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var emptyIds, updatedTags, deletedTags, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          emptyIds = new Set(Object.entries(patientTags).filter(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
              tag = _ref3[1];
            return (tag.changeMode === ChangeMode.ADD || tag.changeMode === ChangeMode.EDIT) && isTagEmpty(tag.value);
          }).map(function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 1),
              id = _ref5[0];
            return Number(id);
          }));
          if (!(emptyIds.size > 0)) {
            _context.n = 1;
            break;
          }
          setShakingTagIds(emptyIds);
          setTimeout(function () {
            return setShakingTagIds(new Set());
          }, 1000);
          return _context.a(2);
        case 1:
          setIsSaving(true);
          updatedTags = [];
          deletedTags = [];
          Object.entries(patientTags).forEach(function (_ref6) {
            var _ref7 = _slicedToArray(_ref6, 2),
              idStr = _ref7[0],
              tag = _ref7[1];
            var tagId = Number(idStr);
            if (tag.changeMode === ChangeMode.DELETE) {
              deletedTags.push({
                tag_id: tagId
              });
            } else if ((tag.changeMode === ChangeMode.ADD || tag.changeMode === ChangeMode.EDIT) && !isTagEmpty(tag.value)) {
              var _fieldsQuery$data;
              var field = (_fieldsQuery$data = fieldsQuery.data) === null || _fieldsQuery$data === void 0 ? void 0 : _fieldsQuery$data.find(function (f) {
                return f.id === tagId;
              });
              var response = (field === null || field === void 0 ? void 0 : field.tag_type) === "date" && tag.value ? new Date(tag.value).toISOString().slice(0, 10) : tag.value;
              updatedTags.push({
                tag_id: tagId,
                response: response
              });
            }
          });
          _context.p = 2;
          _context.n = 3;
          return mutation.mutateAsync({
            updated_tags: updatedTags,
            deleted_tags: deletedTags
          });
        case 3:
          setServerTags(patchServerTags(serverTags, updatedTags, deletedTags));
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          setIsSaving(false);
        case 5:
          setIsSaving(false);
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[2, 4]]);
  })), [patientTags, fieldsQuery.data, serverTags, patientUid, mutation, setServerTags]);
  var onDiscard = useCallback(function () {
    var _getInitialState2 = getInitialState(serverTags),
      pt = _getInitialState2.patientTags,
      o = _getInitialState2.order;
    resetTags(pt, o);
  }, [serverTags, resetTags]);
  var onAddTag = useCallback(function (field) {
    if (!field.id) return;
    addTag(field.id, {
      value: "",
      tagId: field.id,
      changeMode: ChangeMode.ADD
    });
  }, [addTag]);
  var onEdit = useCallback(function (tagId, value, tagType) {
    var _originalTag$response;
    var originalTag = serverTags.find(function (tag) {
      return tag.tag_id === tagId;
    });
    var originalValue = (_originalTag$response = originalTag === null || originalTag === void 0 ? void 0 : originalTag.response) !== null && _originalTag$response !== void 0 ? _originalTag$response : null;
    var normalised = value;
    if (tagType === "date" && typeof value === "string") {
      normalised = value ? new Date(value).toISOString().slice(0, 10) : null;
    }
    var changeMode = normalised === originalValue ? undefined : ChangeMode.EDIT;
    editTag(tagId, value, changeMode);
  }, [serverTags, editTag]);
  var onRemove = useCallback(function (tagId) {
    return deleteTag(tagId);
  }, [deleteTag]);
  var onRevert = useCallback(function (tagId) {
    var _original$response;
    var original = serverTags.find(function (tag) {
      return tag.tag_id === tagId;
    });
    revertTag(tagId, (_original$response = original === null || original === void 0 ? void 0 : original.response) !== null && _original$response !== void 0 ? _original$response : null);
  }, [serverTags, revertTag]);
  var currentTagIds = Object.keys(patientTags).map(Number);
  var hasEmptyTags = Object.values(patientTags).some(function (tag) {
    return (tag.changeMode === ChangeMode.ADD || tag.changeMode === ChangeMode.EDIT) && isTagEmpty(tag.value);
  });
  var numberOfUnsavedChanges = Object.values(patientTags).filter(function (tag) {
    return tag.changeMode !== undefined;
  }).length;
  return {
    tags: serverTags,
    customFields: (_fieldsQuery$data2 = fieldsQuery.data) !== null && _fieldsQuery$data2 !== void 0 ? _fieldsQuery$data2 : [],
    isLoading: tagsQuery.isLoading || fieldsQuery.isLoading,
    isSaving: isSaving,
    saveFailed: mutation.isError,
    isEditingMode: isEditingMode,
    patientTags: patientTags,
    order: order,
    handleSave: handleSave,
    onDiscard: onDiscard,
    onAddTag: onAddTag,
    onEdit: onEdit,
    onRemove: onRemove,
    onRevert: onRevert,
    currentTagIds: currentTagIds,
    shakingTagIds: shakingTagIds,
    hasEmptyTags: hasEmptyTags,
    numberOfUnsavedChanges: numberOfUnsavedChanges
  };
}